<template>

  <div class="c-table-cell">
<!--    <candidate-modal ref="candidateModal" @on-close="onCandidateSidesheetClose" />-->
    <div class="c-table__cell-value">
      <a :href="`javascript:void(0)`" @click="goToCandidateProfile(data.candidate.id)">
        {{ data.value }}
      </a>
    </div>
  </div>
</template>

<script>
import CandidateModal from "@/components/modals/candidate-modal";

export default {
  name: "fullname-cell",
  components: {
    CandidateModal,
  },  
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    // openCandidateHistory(id) {
    //   // alert(id)
    //   this.$refs.candidateModal.openSidesheet({ candidateId: id, tab: "history" });
    //
    //   const classesToDisableRelativePosition = [".sticky-column", ".c-table__header", ".c-table__shadow"];
    //   classesToDisableRelativePosition.forEach((className) => {
    //     document.querySelectorAll(className).forEach((element) => {
    //       element.style.position = "static";
    //     });
    //   });
    // },
    //
    // onCandidateSidesheetClose() {
    //   const classesToEnableRelativePosition = [".sticky-column", ".c-table__header", ".c-table__shadow"];
    //   classesToEnableRelativePosition.forEach((className) => {
    //     document.querySelectorAll(className).forEach((element) => {
    //       if (className === ".sticky-column") {
    //         element.style.position = "sticky";
    //         return;
    //       }
    //       if (className === ".c-table__shadow") {
    //         element.style.position = "absolute";
    //         return;
    //       }
    //       element.style.position = "relative";
    //     });
    //   });
    // },
    goToCandidateProfile(id) {
      this.$router.push({
        name: "candidates-profile",
        params: {
          id,
        },
      });
    },
  }  
};
</script>
